import React, { useCallback } from "react"
import { navigate } from "gatsby"

import { useApp } from "../../../hooks/useApp"
import { useCore } from "../../../hooks/useCore"
import { useCustomerAccessToken, useCustomerContext } from "../../../hooks/useCustomer"

export const withAccountWidget = Component => ({ name = "AccountWidget", activeHeaderHero }: any) => {
  const {
    config: {
      settings: { routes },
    },
    globalStateReducer,
  } = useApp()
  const {
    helpers: { isBrowser },
  } = useCore()

  const { customer } = useCustomerContext()
  const { getCustomer } = useCustomerAccessToken()
  const [{ activeAccount, activeMenu, activeCart }, dispatch] = globalStateReducer

  const isAccountPage = isBrowser && window?.location?.pathname?.includes("/account")

  const handleActiveAccount = useCallback(() => {
    dispatch({
      type: "setActiveAccount",
      payload: !activeAccount,
    })
  }, [activeAccount, dispatch])

  if (!customer) getCustomer()

  const accountLink = routes?.DASHBOARD
  const loginLink = routes?.LOGIN

  const handleClick = () => {
    handleActiveAccount()
    if (customer) {
      navigate(accountLink)
    } else {
      navigate(loginLink)
    }
  }

  const handleClickMobileWidget = () => {
    if (!customer) {
      dispatch({
        type: "setActiveMenu",
        payload: false,
      })
      navigate(loginLink)
    } else {
      handleActiveAccount()
    }
  }

  Component.displayName = name
  return (
    <Component
      handleClick={handleClick}
      handleClickMobileWidget={handleClickMobileWidget}
      activeHeaderHero={activeHeaderHero}
      activeCart={activeCart}
      activeMenu={activeMenu}
      activeAccount={activeAccount}
      handleActiveAccount={handleActiveAccount}
      isAccountPage={isAccountPage}
    />
  )
}
